<template>
    <section class="artigos-hero px-8 py-10">
        <div class="artigos-hero__content">
            <h1 class="hero-title mb-2">{{ title }}</h1>
            <p v-if="subtitle" class="artigos-hero__subtitle ma-0">{{ subtitle }}</p>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ArtigosHero',
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: null },
    },
}
</script>

<style scoped>
.artigos-hero {
    position: relative;
    min-height: 160px;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-dark-violet) 100%);
    color: var(--color-on-primary);
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
    display: flex;
    align-items: center;
    overflow: hidden;
}

.artigos-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.12) 0%, transparent 40%),
        radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.08) 0%, transparent 50%);
    pointer-events: none;
}

.artigos-hero__content {
    position: relative;
    max-width: 720px;
}

.artigos-hero__content .hero-title {
    color: var(--color-on-primary);
}

.artigos-hero__subtitle {
    font-size: 15px;
    opacity: 0.88;
}
</style>
